module.exports = __webpack_public_path__ + "static/img/exhibitFormTips10.6b6c2410.png";